import { Seo, StatusState } from '@/components/molecules';
import { PageIntro, Section } from '@/components/organisms';
import { useAccessoryOrderItems } from '@/hooks/useAccessoryOrderItems';

import { AccessoryCartContent } from './organisms/AccessoryCartContent';

/** Opens WhatsApp with the context of this page. */
export const handle = {
  whatsappMessage: 'Hello Kabex Motors, I have some accessories on my order list.',
};

export default function AccessoryCartPage() {
  const { entries, isPending } = useAccessoryOrderItems();

  return (
    <>
      <Seo
        title="Your order list"
        description="The accessories you have shortlisted with Kabex Motors. Request one order covering all of them."
        path="/accessories/cart"
        noindex
      />
      <PageIntro
        eyebrow="Order list"
        title="Parts you are interested in"
        lede="Add as many as you like, then ask for one order covering all of them. Nothing here is a purchase or a reservation."
        keepOnPhone
      />
      <Section sx={{ py: { xs: 10, md: 16 } }}>
        {entries.length === 0 && !isPending ? (
          <StatusState
            tone="empty"
            title="Your order list is empty"
            description="Browse the accessories we stock and add the ones you would like to order."
            action={{ label: 'Browse accessories', to: '/accessories' }}
          />
        ) : (
          <AccessoryCartContent entries={entries} />
        )}
      </Section>
    </>
  );
}
